import { Divider, FormControl, Grid, MenuItem, Select, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input } from '../../components';
import Header from "./header";
import { Form, useForm } from "../../components/form/UseForm";
import { OnLoginAsyncForOBS, holidayListApi, whoamiAPI } from "../../redux/actions";
import { createAppointment, getQuery } from '../../redux/actions/feedbackFormSlice';
import { useAppDispatch } from "../../store/customHooks";
import { fields } from './fields';
import ThankYou from "./thankyou";

import { validateEmail } from '../../components/validators/inputValidators';
import { MuiDatePicker } from "./dateComponent";
// import compaignDeskTop from '../../components/images/campaignDesktopWinter.jpg';
// import compaignMobile from '../../components/images/campaignMobileMonsoon.jpg';
 
 
const useStyles = makeStyles({
    headings: {
        fontSize: ".875rem",
        color: "#00095b"
    },

    buttun: {
        backgroundColor: "#1C396D !important"
    },
    root: {
        backgroundColor: "#fff",
        padding: "10px"
    },
    bg: {
        backgroundColor: "#ddd"
    }


});
const validateContactNumber = (inputText: any) => {
    const phoneNo = /^\d{10}$/;

    if (inputText.match(phoneNo)) {
        return true;
    } else {
        return false;
    }

};
export const ValidateVINNumber = (inputText: any) => {
    const no = /\b[(A-H|J-N|P|R-Z|0-9)]{17}\b/;
    if (inputText.match(no)) {
        return true;
    } else {
        return false;
    }
}

const UnauthrizedAppointmentBooking = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [thankyou, setThankyou] = useState(false);
    const [ regNo, setRegNo] = useState("");
    const [ vinNo, setVinNo] = useState("");
    const authData = JSON.parse(localStorage.getItem("APPOINTMENT_AUTH_DATA") || "{}");
    const initialFValues = {
        
        mobileNumber: "",
        name: "",
        state: "",
        city: "",
        dealer: "",
        serviceAdvisor: "",
        serviceType: "",
        serviceSubType: "",
        isPickupDropRequired: "",
        verbatim: ""
       // email:"Test@gmai.com"// Change by Sachin
    };

    const [open, setOpen] = useState(false)

    const [referenceNumber, setReferenceNumber] = useState([])
    // const handleClose = () => {
    //     setOpen(false)
    //     loadDropDownOptions("state", "955287", "")
    //     loadDropDownOptions("serviceType", "941822", "")
    //     // setOtpVerified(true)
    //     // setMobileOtpDisabled(true)
    //     setEnableTimer(false)
    //     validate({ ['mobileOTP']: "" }, "")
    //     setFormFields1(fields)
    // };
    const validate = (fieldValues = values, msg: any) => {
        let temp = { ...errors };
        formFields?.forEach((f: any) => {
            if (f.key in fieldValues) {
                temp[f.key] = fieldValues[f.key] ? "" : "Please enter your " + f.label;
            }
        })
        if ("mobileNumber" in fieldValues) {
            temp["mobileNumber"] = fieldValues["mobileNumber"].length == 10 ? "" : msg
        }
        if ("mobileOTP" in fieldValues) {
            temp["mobileOTP"] = fieldValues["mobileOTP"] ? "" : msg
        }
        if ("vin" in fieldValues) {
            temp["vin"] = fieldValues["vin"] ? "" : msg
            temp["vin"] = fieldValues["vin"] && fieldValues["vin"].length == 17 ? "" : fieldValues["vin"] && fieldValues["vin"].length <= 17 ? msg : ""
        }
        if ("regNo" in fieldValues) {
            temp["regNo"] = fieldValues["regNo"] && fieldValues["regNo"].length == 10 ? "" : fieldValues["regNo"] && fieldValues["regNo"].length <= 10 ? msg : ""
        }
        if ("appointmentDate" in fieldValues) {
            temp["appointmentDate"] = fieldValues["appointmentDate"] ? "" : msg
        }
        if ("appointmentTime" in fieldValues) { //added by  rajeev
            temp["appointmentTime"] = msg
            //added
        }
       if ("email" in fieldValues) {
            temp.email = fieldValues.email
                ? !validateEmail(fieldValues.email)
                    ? "Please enter valid email address"
                    : ""
                : "Please enter email address";

        }
         if ("firstName" in fieldValues) {
            temp["firstName"] = fieldValues["firstName"] ? "" : "Please enter your first name"

        }
        // debugger
        setErrors({
            ...temp,
        });

        // Check if any field has error return false else true.
        if (fieldValues == values) return Object.values(temp).every((x) => x == "");
    };
  
    const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false);//added
    // Custom useForm hook.
    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
        useForm({ initialFValues, validateOnChange: true, validate });


   //start 
   const StartTimeAndEndTime=()=>{
    
    let getDealerStartAndEndTime:any={};
        getDealerStartAndEndTime=fields?.find((el:any)=>el.key=='dealer')?.options?.find((el:any)=>el.BranchID==values.dealer);

        const sDate=getDealerStartAndEndTime?.BranchStartTime;
        const eDate=getDealerStartAndEndTime?.BranchEndTime;
        const branchSTime = sDate?.split('T')[1].slice(0, 5);//values.branchStartTime?.split('T')[1];
        const branchEndTime =eDate?.split('T')[1].slice(0, 5); //dealerEndTime?.split('T')[1];

        return {branchSTime,branchEndTime}
}
    const validateAppointmentTime = (selectedTime:any) => { //added for validate dealerTime
       // console.log(formFields)
        
       const getTimes=StartTimeAndEndTime()
       
        const selectedHour = selectedTime//selectedTime.getHours();
    // You may need to further validate minutes if needed
  
    if (selectedHour >= getTimes?.branchSTime && selectedHour <= getTimes?.branchEndTime) {
        return true;
    } else {
        
        return false;
    }
 
}
 
//End added 

    const [error, setError] = useState("");
    const [disabledMobileNo, setDisabledMobileNo] = useState(true)
    const [disableRegNo, setDisabledRegNo] = useState(false);

    let token: any = localStorage.getItem("APPOINTMENT_AUTH_DATA");
    //console.log("............", token)

    useEffect(() => {
        whoami()
        if (!authData?.AuthenticationToken) {
            autoLogin()
        }
    }, []);

    useEffect(() => {
        loadDropDownOptions("state", "955287", "")
        loadDropDownOptions("serviceType", "941822", "")
        loadDropDownOptions("model", "965794", "")

    }, [token]);

    const whoami = async () => {
        await dispatch(whoamiAPI(""))
    }
    const autoLogin = async () => {
        const res: any = await dispatch(OnLoginAsyncForOBS());
        if (res?.payload?.IsLogInSuccessful) {
            localStorage.setItem("APPOINTMENT_AUTH_DATA", JSON.stringify(res?.payload));

        }
    }

    const [formFields, setFormFields]: any = useState([
        // { key: "vin", label: "VIN", type: 'text', helperText: "Please enter your VIN", required: true, disabled: false },
        { key: "model", label: "Model", type: 'select', helperText: "Please enter model", required: true, disabled: false, options: [] },
    ])

    const [formFields1, setFormFields1]: any = useState([])
   //console.log("formFields1", formFields1);

    const redirect = () => {
        navigate("/appointmentBooking");
        setThankyou(!thankyou)
    }
    const onInputHandleChange = async (e: any) => {
        setError("");
        const { name, value } = e.target;
      if (name === 'vin') {
            if (value != " " && value.length <= 17) {
                setVinNo(value);
                setRegNo("");
                validate({ [name]: value }, "Please enter 17 characters VIN");

            } else {
                validate({ [name]: value }, "Please enter 17 characters VIN");


            }
        }
        else if (name === 'regNo') {
            console.log("state changed")

            if (value != " " && value?.trim().length <= 12) {
                setRegNo(value);
                validate({ [name]: value }, " ");
            } else {
                validate({ [name]: value }, "Please enter 12 characters RegNo");
            }

        }
    }
    const onInputChange = async (e: any) => {
  
        setError("")
        const { name, value } = e.target;
        if (name === "mobileNumber") {
            if (value.length <= 10) {
                setEnableTimer(false);

                let getValidatedNumber = validateContactNumber(value);
                setValues({ ...values, [name]: value, mobileOTP: "" });
                setFormFields1([])
                if (getValidatedNumber) {
                    validate({ [name]: value }, "");
                } else {
                    validate({ [name]: value }, "Please enter a valid 10-digit mobile number");
                }
            } else {
                validate({ [name]: value }, "");

            }
        }
        else if (name === "appointmentDate") {
            //  https://fordtst.excelloncloud.com/api/OnlineBooking/IsHoliday
            let d = moment(new Date(value)).format("YYYY-MM-DD") //added
           
            const payload = {
                AuthenticationToken: authData?.AuthenticationToken,
                ManagerKey: authData?.ProfileManagerKey,
                "AppointmentDate": d + " " + "00:00",
                "BranchID": values.dealer
            };
            const res: any = await dispatch(holidayListApi(payload));
            if (res?.payload?.Data?.IsRequestSuccessful == true) {
                setValues({ ...values, [name]: "" });
                validate({ [name]: "" }, res?.payload?.Data?.ErrorMsg);
            } else {
                if (value != " ") {
                    setValues({ ...values, [name]: value });
                    validate({ [name]: value }, "");
                }
            }
        } else {
            if (value != " ") {
                setValues({ ...values, [name]: value });
            }
            validate({ [name]: value }, "");
        }
        if (name === "appointmentTime") { //added by Rajeev 
            // Check if the selected appointment time is within the dealer's working hours
            const getTime= validateAppointmentTime(value);
            if (getTime) {
               
            validate({ [name]: value }, "");
            } else {
         
                // Show error message if the selected time is outside working hours
                const getTimes=StartTimeAndEndTime()
              
             validate({ [name]: value }, `Please select your preferred time slot between ${getTimes?.branchSTime} to ${getTimes?.branchEndTime}`);
             setValues({ ...values, [name]: "" });
            }
        } 

        if (name === "state") {
            console.log("state changed")
            setValues({ ...values, [name]: value, city: "", dealer: "", serviceAdvisor: "" });
            loadDropDownOptions("city", "955288", "StateID=" + value)
        }
        if (name === "city") {
            setValues({ ...values, [name]: value, dealer: "", serviceAdvisor: "" });

            loadDropDownOptions("dealer", "955286", "CityID=" + value)

        }
        if (name === "dealer") {
            setValues({ ...values, [name]: value, serviceAdvisor: "", appointmentDate: "",appointmentTime: ""  });

            let date: any = new Date();
            loadDropDownOptions("serviceAdvisor", "941816", `(BranchID = ${value})  AND ((FromDate <= '${date?.toISOString().slice(0, date?.toISOString().indexOf('T')).toString()}' AND ToDate >= NULL) OR ToDate is NULL)`)
            validate({ appointmentTime: "" }, "");
        }

        if (name === "serviceType") {

            loadDropDownOptions("serviceSubType", "942144", `(ISNULL(ServiceContractID,0) = ${value} OR ISNULL(ServiceContractID,0) = 0)`)
          

            setValues({ ...values, serviceSubType: value === 38 ? 15 : value === 47 ? 14 : value === 46 ? 14 : "", [name]: value });

        }

         if (name === "email") {
            if (value.length <= 1) {
                setEnableTimer(false);

                let getValidatedEmail = validateEmail(value);
                setValues({ ...values, [name]: value, mobileOTP: "" });
                setFormFields1([])
                if (getValidatedEmail) {
                    validate({ [name]: value }, "");
                } else {
                    validate({ [name]: value }, "Please enter a valid 10-digit mobile number");
                }
            } else {
                validate({ [name]: value }, "");

            }
        }


    };

    const clearSession = () => {
        localStorage.clear()
    }

    const onSubmit = async (e: any) => { //need to update time 
        e.preventDefault()
        let date = moment(new Date(values?.appointmentDate)).format("YYYY-MM-DD") + " " + values.appointmentTime;

        //let date = values?.appointmentDate + " " + values?.appointmentTime;
        let payload = {
            AuthenticationToken: authData?.AuthenticationToken,
            ManagerKey: authData?.ProfileManagerKey,
            "BranchID": values.dealer,
            "RegistrationNo": regNo,
            "VIN": vinNo,
            "FirstName": values.firstName,
            "LastName": values.lastName,
            "Mobile": values.mobileNumber,
            "AdvisorID": values.serviceAdvisor ? values.serviceAdvisor : 0,
            "AppointmentDate": date,
            "SoureID": 4,
            "ServiceTypeID": values.serviceType ? values.serviceType : 0,
            "ServiceSubTypeID": values.serviceSubType ? values.serviceSubType : 0,
            "CustomerVerbatim": values.verbatim,
            // "ModelName": values.ModelName,
            "ModelID": values.model,
            "IsPickDropRequired": values.isPickupDropRequired ? values.isPickupDropRequired : 0,
            "EmailAddress": values.email,
            "KMReading": parseInt(values?.KMReading)
        }
        const res = await dispatch(createAppointment(payload));

        if (res?.payload?.Data?.IsRequestSuccessful) {
            setReferenceNumber(res?.payload?.Data?.ReferenceNumber)
            setThankyou(true)
            clearSession()
        }


    }

    const [enableTimer, setEnableTimer] = useState(false);

    const loadDropDownOptions = async (field: any, FieldID: any, FilterString: any) => {
        let payload = {
            AuthenticationToken: authData?.AuthenticationToken,
            ManagerKey: authData?.ProfileManagerKey,
            "FieldID": FieldID,
            "ViewID": "900182",
            "FilterCompanyID": "0",
            "SelectString": "",
            "FilterString": FilterString,
            "SortString": "",
            "IsDistinct": "false",
            "PageNumber": "0",
            "PageSize": "50"
        }
        const res = await dispatch(getQuery(payload));

        if (res?.payload?.IsRequestSuccessful) {

            let _formFields = fields.map((f: any) => {
                if (f.key === field) {
                    if (field === "serviceType") {
                        f.options = res?.payload?.Data?.Table?.filter((f: any) => f.ID == 38 || f.ID == 46 || f.ID == 47)
                    } else if (field === "serviceSubType") {
                        let response = res?.payload?.Data?.Table
                        f.options = response
                        f.value = response.length === 1 && response[0].ID
                    } else {
                        f.options = res?.payload?.Data?.Table
                    }
                    f.disabled = false
                }

                if (field === "dealer") {
                    f.disabled = false
                }
                if (f.key === "serviceSubType") {
                    f.disabled = true
                }

                return f;
            })
            setFormFields1([..._formFields])

        }
        if (res?.payload?.IsRequestSuccessful) {
            let result = formFields.map((f: any) => {
                if (f.key === field) {
                    if (field === "model") {
                        let response = res?.payload?.Data?.Table
                        f.options = response
                        f.value = response.length === 1 && response[0].ID
                    }
                    else {
                        f.options = res?.payload?.Data?.Table
                    }
                }
            })
            setFormFields1([...result])

        }


    }

    const [vinRegErrorMsg, setVinRegErrorMsg] = useState("")
    // const [isValid, setIsValid] = useState(true);

    return (

        <div>
            <Header position={'static'} />
            <Grid container spacing={1} className={classes.bg}>
                <Grid item xs={12} sm={12} textAlign={'center'} >
                    {!thankyou ?
                        <>
                            <Form style={{ padding: 10 }}>

                                <Grid container >
                                    <Grid item xs={12} sm={12} textAlign={'center'} marginTop={2}>

                                        <Typography variant="h5" className={classes.headings}>Book A Service</Typography>

                                    </Grid>
                                    <Grid item xs={12} sm={0} md={3}>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} textAlign={'center'} className={classes.root}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={5.7} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px' }}>Vehicle Registration Number<span style={{ color: 'red' }}>*</span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;</div>
                                                <Input
                                                    required={true}
                                                    placeholder={"eg. DLXXAAXXXX"}
                                                    name={"regNo"}
                                                    type={"text"}
                                                    value={regNo}
                                                    onChange={onInputHandleChange}
                                                    error={errors["regNo"]}
                                                    size={'small'}
                                                    disabled={disableRegNo}
                                                ></Input>

                                            </Grid>
                                            <Grid item xs={12} sm={0.6} textAlign={'left'} alignSelf={'center'}>
                                                <div>&nbsp; OR</div>
                                            </Grid>
                                            <Grid item xs={12} sm={5.7} textAlign={'left'}>

                                                <div style={{ marginBottom: '5px' }}>VIN (Vehicle Identification Number) / Chassis Number <span style={{ color: 'red' }}>*</span></div>
                                                <Input
                                                    required={true}
                                                    // placeholder={"VIN"}
                                                    name={"vin"}
                                                    type={"text"}
                                                    value={vinNo}
                                                    onChange={onInputHandleChange}
                                                    error={errors["vin"]}
                                                    size={'small'}
                                                    disabled={disableRegNo}
                                                    placeholder={"eg. MALAA82HR4M000000"}
                                                ></Input>

                                            </Grid>


                                            <Grid item xs={12} sm={12} textAlign={'left'}>
                                                <div><span style={{ color: 'red' }}>{vinRegErrorMsg}</span></div>
                                            </Grid>
                                            {/* //Model */}
                                            {formFields?.map((f: any) => {
                                                return <Grid item key={f.key} xs={12} sm={6} textAlign={'left'} >
                                                    <div style={{ marginBottom: '5px' }}>{f.label} {f.required && <span style={{ color: 'red' }}>*</span>}</div>
                                                    <FormControl fullWidth>
                                                        <Select
                                                            //labelId="demo-simple-select-label"
                                                            id={f.key}
                                                            value={f.value || values[f.key]}
                                                            placeholder={f.label}
                                                            size={'small'}
                                                            name={f.key}
                                                            onChange={onInputChange}
                                                            error={errors[f.key]}
                                                            displayEmpty
                                                            disabled={f.disabled}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <>Select</>
                                                            </MenuItem>
                                                            {f?.options?.map((i: any) => {
                                                                return <MenuItem value={i?.ID}>{i?.Name}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            })}
                                        </Grid>
                                        <br />
                                        <Grid container spacing={2}>


                                            <Grid item xs={12} sm={12} textAlign={'left'}><Typography color={'#00095b'} variant="h6">Personal Details</Typography><Divider /></Grid>
                                            <Grid item xs={12} sm={6} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px' }}>Mobile Number <span style={{ color: 'red' }}>*</span></div>
                                                <Input
                                                    required={true}
                                                    placeholder={"Mobile Number"}
                                                    name={"mobileNumber"}
                                                    type={"number"}
                                                    value={values["mobileNumber"]}
                                                    onChange={onInputChange}
                                                    error={errors["mobileNumber"]}
                                                    size={'small'}
                                                    style={{ paddingRight: 0 }}
                                                    inputProps={{ min: "1" }}
                                                // disabled={disabledMobileNo}


                                                ></Input>

                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} textAlign={'left'}>
                                                <div style={{ marginBottom: '5px' }}>Email <span style={{ color: 'red' }}>*</span></div>
                                                <Input
                                                    required={true}
                                                    placeholder={"Email"}
                                                    name={"Email"}
                                                    type={"string"}
                                                    value={values["email"]}
                                                    onChange={onInputChange}
                                                    error={errors["email"]}
                                                    size={'small'}
                                                    style={{ paddingRight: 0 }}
                                                    inputProps={{ min: "1" }}
                                                // disabled={disabledMobileNo

                                                ></Input>

                                            </Grid> */}

                                            {fields?.map((f: any) => {
                                                return f.type === "header" ?
                                                    <Grid item xs={12} sm={12} textAlign={'left'}><Typography color={'#00095b'} variant="h6">{f.label}</Typography><Divider /></Grid>

                                                    : <Grid item key={f.key} xs={12} sm={6} textAlign={'left'} style={{ "visibility": f.key === "serviceSubType" ? "hidden" : "unset" }}>
                                                        <div style={{ marginBottom: '5px' }}>{f.label} <span style={{ fontSize: "10px" }}>{f.key === "appointmentTime"}</span> {f.required && <span style={{ color: 'red' }}>*</span>}</div>


                                                        {f.type == "select" ? <FormControl fullWidth>

                                                            <Select
                                                                //labelId="demo-simple-select-label"
                                                                id={f.key}

                                                                value={f.value || values[f.key]}
                                                                placeholder={f.label}
                                                                size={'small'}
                                                                name={f.key}
                                                                onChange={onInputChange}
                                                                error={errors[f.key]}
                                                                displayEmpty
                                                                disabled={f.disabled}

                                                            >
                                                                <MenuItem disabled value="">
                                                                    {f.key === "serviceAdvisor" ? "No Selection" : "Select"}
                                                                </MenuItem>
                                                                {f.options?.map((i: any) => {
                                                                    return f.key === "dealer" ? <MenuItem key={i.BranchID} value={i.BranchID}>{i.BranchName}</MenuItem> :
                                                                        f.key === "state" ? <MenuItem key={i.StateID} value={i.StateID}>{i.StateName}</MenuItem> :
                                                                            f.key === "city" ? <MenuItem key={i.CityID} value={i.CityID}>{i.CityName}</MenuItem> :
                                                                                f.key === "serviceAdvisor" || f.key === "serviceType" || f.key === "serviceSubType" ? <MenuItem key={i.ID} value={i.ID}>{i.Name}</MenuItem> : <MenuItem value={i.value}>{i.label}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl> :

                                                            f.type === "date" ?

                                                                <MuiDatePicker
                                                                    label={f.placeholder}
                                                                    name={f.key}
                                                                    value={values[f.key]}
                                                                    onChange={onInputChange}

                                                                    placeholder={f.placeholder}
                                                                    required={f.required}
                                                                    disabled={f.disabled}
                                                                    renderInput={(e: any) => {
                                                                        e.preventDefault();
                                                                    }}
                                                                    // minDate ={moment().add(2, 'days').format("YYYY-MM-DD")}
                                                                    // maxDate={ moment().add(1, 'month').format("YYYY-MM-DD")}

                                                                    error={errors[f.key]}
                                                                    size={'small'}
                                                                />


                                                                :
                                                                f.type === "time" ? <Input
                                                                    required={f.required}
                                                                    disabled={f.disabled}
                                                                    // label={f.label}
                                                                    placeholder={f.placeholder}
                                                                    name={f.key}
                                                                    type={f.type}
                                                                    value={values[f.key]}
                                                                    onChange={onInputChange}
                                                                    error={errors[f.key]}
                                                                    size={'small'}

                                                                ></Input> :

                                                                    <Input
                                                                        required={f.required}
                                                                        disabled={f.disabled}
                                                                        // label={f.label}
                                                                        placeholder={f.placeholder ? f.placeholder : f.label}
                                                                        name={f.key}
                                                                        type={f.type}
                                                                        value={values[f.key]}
                                                                        onChange={onInputChange}
                                                                        error={errors[f.key]}
                                                                        size={'small'}
                                                                        inputProps={{ min: 0 }}

                                                                    ></Input>}
                                                    </Grid>
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} sm={0} md={2}>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={8}>
                                            {/* <p>“This Online Service Booking facility is currently available for limited-service outlets only, we are on the process of expanding the same soon for other location(s)”</p> */}
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={12} sm={0} md={2}>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={8} textAlign={'center'} marginTop={2}>
                                            <p>I agree to receive calls, e-mail and SMS from Ford India Private Limited (“Ford”), its agents, and its dealers on my mobile phone, which are intended to assist me in availing service. I also agree to receive such and any other marketing & product related communication from Ford, its agents, and its dealers until specified otherwise, by me.</p>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} textAlign={'center'} marginTop={2}>

                                        <Button
                                            name="Submit"
                                            disabled={
                                                !(regNo || vinNo)
                                                || !values?.mobileNumber
                                                || values?.mobileNumber.length !== 10
                                                || !values?.firstName
                                                || !values?.model
                                                || !values?.state
                                                || !values?.city
                                                || !values?.dealer
                                                || !values?.appointmentDate
                                                || !values?.appointmentTime
                                                || !values?.serviceType  
                                                || (values?.email && !validateEmail(values?.email))
                                                
                                                //|| !values?.verbatim
                                            }
                                            type="submit"
                                            onClick={(e: any) => {
                                                onSubmit(e);
                                            }}
                                            className={classes.buttun}
                                        />                                       
                                    </Grid>

                                </Grid>

                            </Form>
                           
                        </>
                        : <div>
                            <ThankYou referenceNumber={referenceNumber} />
                        </div>
                    }

                </Grid>
            </Grid>
            {/* <Grid
                container
                spacing={2}
                style={{ marginTop: '0' }}
                justifyContent="center"
                alignItems="center"
            >
                <Grid item xs={12}>
                    <img
                        src={compaignDeskTop}
                        style={{
                            width: "100%",
                            height: '100%',
                            objectFit: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}
                        alt="Campaign"
                    />
                </Grid>
            </Grid> */}
        </div>
    );
};

export default UnauthrizedAppointmentBooking;
